import React, { useEffect } from 'react';
import { useGlobalContext } from '../../js/context';
import Button from '../button/Button.jsx';
import Video from '../video/Video.jsx';
import HomepageAnime from './HomepageAnime.js';
import { gtmTracking, gtm4Tracking } from '../../js/helpers';
import './Homepage.scss';
import ReactGA from 'react-ga4';

const Homepage = () => {
	const { changePageHandler, isSafari, isTablet, fullScreenHandler } =
		useGlobalContext();

	useEffect(() => {
		HomepageAnime();
		ReactGA.send({ hitType: 'pageview', page: 'Homepage', title: 'Homepage' });
	}, []);

	return (
		<div className='tos-homepage tos-hide-before-animated'>
			<h1 className='tos-homepage__title'>What’s the difference?</h1>

			<div className='tos-homepage__content'>
				<div className='tos-homepage__content-text tos-homepage__content-text--left'>
					<h2>The smoke</h2>
					<span>from a cigarette</span>
				</div>
				<div className='tos__homepage-video tos__homepage-video--left'>
					<Video
						videoSource={
							isSafari
								? 'https://www.pmi.com/resources/tools-for-science/videos/homepage-safari-smoke.mp4'
								: 'https://www.pmi.com/resources/tools-for-science/videos/homepage-chrome-smoke.webm'
						}
						videoType={isSafari ? 'mp4' : 'webm'}
					/>
				</div>
				<div className='tos-homepage__separator'>
					<div className='tos-homepage__separator-line tos-homepage__separator-line--before tos-hide-before-animated'></div>
					<span className='sliced-element tos-hide-before-animated'>V</span>
					<span className='sliced-element tos-hide-before-animated'>S</span>
					<div className='tos-homepage__separator-line tos-homepage__separator-line--after tos-hide-before-animated'></div>
				</div>
				<div className='tos-homepage__content-text tos-homepage__content-text--right'>
					<h2>The aerosol</h2>
					<span>from our heated tobacco product</span>
				</div>
				<div className='tos__homepage-video tos__homepage-video--right'>
					<Video
						videoSource={
							isSafari
								? 'https://www.pmi.com/resources/tools-for-science/videos/homepage-safari-vapour.mp4'
								: 'https://www.pmi.com/resources/tools-for-science/videos/homepage-chrome-vapour.webm'
						}
						videoType={isSafari ? 'mp4' : 'webm'}
					/>
				</div>
			</div>

			<Button
				className='tos-homepage__button tos-hide-before-animated'
				title={`${isTablet ? 'START' : 'START IN FULLSCREEN'}`}
				arrowPosition='right'
				onClick={() => {
					changePageHandler('overview_page');
					gtm4Tracking({event: 'GA4_event_c_tfs_start'});
					gtmTracking('navigation', 'start');
					!isTablet && fullScreenHandler(true);
				}}
				hasHover
			>
				<svg
					width='16'
					height='17'
					viewBox='0 0 16 17'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						d='M3 8.5H12.5M12.5 8.5C12.5 8.5 9.86683 5.86683 8.5 4.5M12.5 8.5C12.5 8.5 9.86683 11.1332 8.5 12.5'
						stroke='#0074C2'
					/>
				</svg>
			</Button>
		</div>
	);
};

export default Homepage;
